import {
    ModelBase
} from "../base"

export class WorkflowModel extends ModelBase {
    id = 0;
    name = "";
    systemCode = "";
    moduleRefId = 0;
    workflowSteps = [
        new WorkflowStepModel()
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class WorkflowStepModel extends ModelBase {
    id = 0;
    moduleRefId = "";
    rank = 0;
    systemCode = "";
    workflowId = 0;
    constructor(params) {
        super();
        this.mapModel(params);
    }
}